import { useMemo } from 'react';
import axios from 'axios';
import { auth } from './components/firebase_utils/firebase';
import { getIdToken } from 'firebase/auth';
import { toast } from 'react-toastify';

const runtimeConfig = window.__CONFIG__ || {};

const useApi = () => {
  const environment =
    runtimeConfig.REACT_APP_ENVIRONMENT ||
    process.env.REACT_APP_ENVIRONMENT ||
    'development';

  const baseURL =
    environment === 'production'
      ? runtimeConfig.REACT_APP_API_BASE_URL_PROD ||
        process.env.REACT_APP_API_BASE_URL_PROD ||
        ''
      : runtimeConfig.REACT_APP_API_BASE_URL_DEV ||
        process.env.REACT_APP_API_BASE_URL_DEV ||
        '';

  const apiClient = useMemo(() => {
    const client = axios.create({ baseURL });

    client.interceptors.request.use(
      async (config) => {
        const user = auth.currentUser;
        if (user) {
          const token = await getIdToken(user);
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    client.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 429) {
          toast.error('You have made too many requests. Please wait and try again later.', {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
        return Promise.reject(error);
      }
    );

    return client;
  }, [baseURL]);

  return apiClient;
};

export default useApi;
